import { ValueInput } from '@/components/form/ValueInput.tsx';
import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';

export const IdFilterInput = ({ form, index }: FilterInputProps) => (
  <ValueInput
    size="toolbar"
    placeholder="Wpisz wartość"
    register={form.register(`filters.${index}.value`)}
  />
);
